import {call, put, select, takeEvery} from "redux-saga/effects";
import {
    onCategoriesChangeItemPosition, onCategoriesChangeItemPositionFail, onCategoriesChangeItemPositionSuccess,
    onCategoriesChangePosition,
    onCategoriesChangePositionFail,
    onCategoriesChangePositionSuccess, onCategoriesEdit, onCategoriesEditFail, onCategoriesEditSuccess,
    onCategoriesLoad,
    onCategoriesLoadFail,
    onCategoriesLoadSuccess, onCategoriesModalEdit, onCategoriesNew, onCategoriesNewFail, onCategoriesNewSuccess
} from "./actions";
import {addNewCategory, changeItemPosition, changePosition, editNewCategory, loadCategories} from "../api";

function* fetchInitData(action) {
    try {
        const categories = yield select(state => state.categories);

        const filter = {
            status: categories.status,
        }
        const response = yield call(loadCategories, filter)
        yield put(onCategoriesLoadSuccess(response))
    }
    catch (e) {
        yield put(onCategoriesLoadFail())
    }
}

function* onChangePosition(action) {
    try {
        const response = yield call(changePosition, action.items)
        yield put(onCategoriesChangePositionSuccess(response))
    }
    catch (e) {
        yield put(onCategoriesChangePositionFail())
    }
}
function* onChangeItemPosition(action) {
    try {
        const response = yield call(changeItemPosition, action.items)
        yield put(onCategoriesChangeItemPositionSuccess(response))
    }
    catch (e) {
        yield put(onCategoriesChangeItemPositionFail())
    }
}

function* newCategory(action) {
    try {
        const response = yield call(addNewCategory, action.name)
        yield put(onCategoriesNewSuccess(response))
        yield put(onCategoriesLoad())
    }
    catch (e) {
        yield put(onCategoriesNewFail())
    }
}
function* editCategory(action) {
    try {
        const response = yield call(editNewCategory, action.category, action.archived)
        yield put(onCategoriesEditSuccess(response))
        yield put(onCategoriesLoad())
        yield put(onCategoriesModalEdit(false))
    }
    catch (e) {
        yield put(onCategoriesEditFail(e))
    }
}


function* categoriesSaga() {
    yield takeEvery(onCategoriesLoad().type, fetchInitData);
    yield takeEvery(onCategoriesChangePosition().type, onChangePosition);
    yield takeEvery(onCategoriesChangeItemPosition().type, onChangeItemPosition);
    yield takeEvery(onCategoriesNew().type, newCategory);
    yield takeEvery(onCategoriesEdit().type, editCategory);
}

export default categoriesSaga;
